import { cn } from "~/utils";

/** The kinds the backend tags clusters with, plus the unfiltered view. */
export type ClusterType = "all" | "mt" | "st" | "byoc";

export const CLUSTER_TYPE_NAMES: Record<ClusterType, string> = {
  all: "all clusters",
  mt: "multi-tenant",
  st: "single-tenant",
  byoc: "bring your own cloud",
};

interface FilterToggleProps {
  selectedType: ClusterType;
  onTypeChange: (type: ClusterType) => void;
  className?: string;
}

export function FilterToggle({
  selectedType,
  onTypeChange,
  className,
}: FilterToggleProps) {
  const options: { value: ClusterType; label: string; shortcut: string }[] = [
    { value: "all", label: "all", shortcut: "1" },
    { value: "mt", label: "mt", shortcut: "2" },
    { value: "st", label: "st", shortcut: "3" },
    { value: "byoc", label: "byoc", shortcut: "4" },
  ];

  return (
    <div
      className={cn(
        "flex h-9 rounded-sm border border-border-contrast bg-background",
        className,
      )}
    >
      {options.map((option, index) => (
        <button
          key={option.value}
          onClick={() => onTypeChange(option.value)}
          title={`${CLUSTER_TYPE_NAMES[option.value]} (${option.shortcut})`}
          className={cn(
            "relative flex h-full flex-1 items-center justify-center px-3 text-xs font-medium transition-all focus-visible:outline-none focus-visible:ring focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 sm:flex-initial",
            // First button - rounded left
            index === 0 && "rounded-l-sm",
            // Last button - rounded right
            index === options.length - 1 && "rounded-r-sm",
            // Border between segments
            index !== options.length - 1 && "border-r border-border-contrast",
            // Selected state
            selectedType === option.value
              ? "bg-slate-200 text-slate-900"
              : "bg-background text-foreground hover:bg-ghost active:bg-ghost",
          )}
        >
          <span>{option.label}</span>
          <kbd className="absolute right-1 top-0.5 hidden rounded bg-gray-100 px-0.5 py-0 text-[10px] leading-none text-gray-400 sm:block">
            {option.shortcut}
          </kbd>
        </button>
      ))}
    </div>
  );
}
